import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../configs/constants/routes";
import NotFoundComponent from "../Shared/NotFoundComponent/NotFoundComponent";
import { useAuthStore } from "../../stores/auth.store";

const FullScreenPrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const authStore = useAuthStore();
	const navigate = useNavigate();

	if (!authStore.isLoggedIn) {
		navigate(routes.LOGIN, { replace: true });
	}

	if (!authStore.initiated || !authStore.isLoggedIn) return <NotFoundComponent />;

	// Return children directly without any layout wrapper for full-screen experience
	return <>{children}</>;
};

export default FullScreenPrivateRoute;
